import React from 'react';
import { AppState } from 'acscp/store';
import { connect } from 'react-redux';
import { LanguageSign } from './languageSign';
import { LocaleCode } from 'acscp/translations';

interface LanguageMenuButtonStateProps {
    currentLocale: LocaleCode;
}

export class LanguageMenuButtonPresentational
    extends React.Component<LanguageMenuButtonStateProps> {
    render(): JSX.Element {
        return (
            <LanguageSign localeCode={this.props.currentLocale} />
        );
    }
}

function mapStateToProps(state: AppState, ownprops: {}): LanguageMenuButtonStateProps {
    return {
        currentLocale: state.intl.locale,
    };
}

export const LanguageMenuButton = connect(mapStateToProps)(LanguageMenuButtonPresentational);
